import { Currency } from "../../interfaces/currency";
import { FIAT_TYPE } from "@helpers/constants";

export class Fiat extends Currency {
	protected static readonly currencyType: string = FIAT_TYPE;

	private to_eur_rate: string = "";
	private precision: number = -1;
	private has_wallets: boolean = false;
	private numeric_character_reference = "";
	private wallet_min_withdrawal: string = "";
	private symbol_character: string = "";
	private logo_white: string = "";
	private logo_color: string = "";
	private wallet_min_deposit: string = "";

	public getCurrencyType(): string {
		return Fiat.currencyType;
	}

	public getPrecision(): number {
		return this.precision;
	}

	public toEuroRate(): number {
		return +this.to_eur_rate;
	}

	public getHtmlSign(): string {
		return this.numeric_character_reference;
	}

	public getSymbolCharacter(): string {
		return this.symbol_character;
	}

	public hasWallet(): boolean {
		return this.has_wallets;
	}

	public getPrecisionFiat(): number {
		return this.getPrecision();
	}

	public getMinWalletWithdraw(): string {
		return this.wallet_min_withdrawal;
	}

	public getIconCssName(lc: boolean = false): string {
		return "bpi__asset-" + this.getSymbol(lc);
	}

	public getLogoWhite(): string {
		return this.logo_white;
	}

	public getLogoColor(): string {
		return this.logo_color;
	}

	public getWalletMinDeposit(): number {
		return +this.wallet_min_deposit;
	}
}
